import { buildPrompt } from '@/ai/utils/promptBuilder'
import { sanitizeCardDescription } from '@/utils/sanitize'
import { transformWorkflow } from '@/ai/utils/transformWorkflow'
import { systemMessages } from '@/ai/prompts/common/systemMessages'
import { getJsonOutputFormatting } from '@/ai/prompts/common/formatting'
import { createUserMessage, createSystemMessage } from '@/ai/utils/promptUtils'

export const buildCommentReplyPrompt = ({ workflow, input }) => {
  const messages = []

  const systemContent = buildPrompt([systemMessages.EVENT_MODELING_DDD_EXPERT])
  messages.push(createSystemMessage(systemContent))

  const promptSections = []

  const card = input.node.requirementsJson.find((card) => card.id === input.requirementId)
  const { events, entities, eventIdToLongIdMap } = transformWorkflow(workflow)
  const event = events.find((e) => eventIdToLongIdMap[e.id] === input.node.id) || {}

  promptSections.push({
    title: 'Request',
    content: `Answer this question: ${sanitizeCardDescription(input.text)}`,
    spacingAfter: 1
  })

  promptSections.push({
    content: `
      The Request above specifically refers to the domain event ${event.id} (${event.role} - ${event.name})
      in the workflow and the meta data: ${card.cardType.title} "${card.description}".
    `,
    spacingAfter: 1
  })

  if (card.comments?.length > 1) {
    promptSections.push({
      content: 'Here you can see the question in the context of previous comments:',
      spacingAfter: 1
    })
    card.comments.forEach((comment, index) => {
      promptSections.push({
        content: `> ${sanitizeCardDescription(comment.text)}`,
        spacingAfter: index === card.comments.length - 1 ? 2 : 1
      })
    })
  }

  promptSections.push({
    title: 'Current Workflow (JSON format)',
    contentType: 'codeblock',
    language: 'json',
    content: JSON.stringify({ domainEvents: events })
  })

  promptSections.push({
    title: 'Existing Entities (Optional): Use this information if applicable.',
    contentType: 'codeblock',
    language: 'json',
    content: JSON.stringify({ entities })
  })

  const example = { message: 'This is an example message' }

  promptSections.push({
    title: 'Formatting',
    flattenLines: false,
    content: getJsonOutputFormatting('message', JSON.stringify(example))
  })

  const userContent = buildPrompt(promptSections)
  messages.push(createUserMessage(userContent))

  return messages
}
